import type { AppDispatch } from '@/shared/store'
import { removeCurrent } from '../../layer/layerSlice'
import { addDeletedLayerId } from '../../slide/slideSlice'

/**
 * Remove a layer from a slide.
 * Removes from the layer adapter and tracks the deletion in the slide
 * if it's a server-side layer (positive ID).
 */
export const removeLayer = (
  payload: { slideId: number; layerId: number },
) => (dispatch: AppDispatch) => {
  const { slideId, layerId } = payload

  dispatch(removeCurrent(layerId))

  // Track server-side layers for DELETE ops on sync
  if (layerId > 0) {
    dispatch(addDeletedLayerId({ slideId, layerId }))
  }
}
